"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSyncFunction = void 0;
const get_type_1 = require("./get-type");
exports.isSyncFunction = (value) => get_type_1.getType(value) === "[object Function]";
//# sourceMappingURL=is-sync-function.js.map